import styled from '@emotion/styled';
import GoogleLogoSvg from './google-logo.svg?react';

const GoogleLogo = styled(GoogleLogoSvg)({
  margin: -12.5,
});

export default GoogleLogo;
